import { Mongo } from "meteor/mongo";
import { Message } from "lib";

export const Messages = new Mongo.Collection<Message>("messages");
